import React from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

import { useResponsive } from '../hooks/useResponsive';

const GEOCODING_SERVICE_URL = 'https://api.maptiler.com/geocoding';
const GEOCODER_KEY = process.env.REACT_APP_MAPTILER_API_KEY;

const geocoder = {
  search: async (q, language = 'fr') => {
    const url = `${GEOCODING_SERVICE_URL}/${q}.json?language=${language}&types=joint_submunicipality,region,subregion,country,municipality,joint_municipality,municipal_district,county,locality&key=${GEOCODER_KEY}`;
    const results = fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong');
      })
      .catch((error) => {
        console.log(error);
      });
    return results;
  },
};

export const getGeolocationPermission = () => {
  if (navigator.permissions) {
    return navigator.permissions.query({ name: 'geolocation' });
  } else {
    return new Promise((resolve) => {
      resolve({
        state: 'granted',
      });
    });
  }
};

export const GeocoderInput = ({ locationFeature, setLocationFeature }) => {
  const [mouting, setMounting] = React.useState(true);
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');
  const { isMobile } = useResponsive();
  const { t, i18n } = useTranslation();

  const onType = async (evt, newValue) => {
    if (mouting) {
      return;
    }
    if (newValue !== null && newValue !== '') {
      const results = await geocoder.search(newValue, i18n.language);
      if (results !== undefined) {
        const { features } = results;
        const options = features.map((feature) => ({
          ...feature,
          coord: feature.geometry.coordinates,
          label: feature.place_name,
        }));
        setOptions(options);
      } else {
        setOptions([]);
      }
    } else {
      setOptions([]);
    }
  };

  const handleChangeInput = async (evt, newValue) => {
    if (mouting) {
      return;
    }
    if (newValue !== null || typeof newValue !== 'object') {
      setLocationFeature(newValue);
    } else {
      return;
    }
  };

  React.useEffect(() => {
    if (locationFeature) {
      setValue(`${locationFeature.place_name}`);
    } else {
      setValue('');
    }
    setMounting(false);
    return () => {
      setMounting(true);
    };
  }, [locationFeature]);

  return (
    <Autocomplete
      id='address'
      sx={{
        display: 'flex',
        '& input': {
          fontSize: '1.1em',
        },
        '& input::placeholder': {
          fontSize: '1.1em',
          color: 'black',
          opacity: 0.6,
        },
        '& button': {
          visibility: 'visible',
        },
        minWidth: isMobile ? 200 : 300,
        width: '100%',
      }}
      open={open}
      onOpen={() => {
        setTimeout(() => {
          setOpen(true);
        }, 500);
      }}
      onClose={() => setOpen(false)}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.place_name}
          </li>
        );
      }}
      options={options}
      onInputChange={onType}
      onChange={handleChangeInput}
      value={value}
      freeSolo
      autoComplete
      autoHighlight
      includeInputInList
      filterSelectedOptions
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '15px',
              },
            }}
            placeholder={t('welcome_page.placeholder_city')}
            size='small'
          />
        );
      }}
    />
  );
};
